<template>
  <div>
    <Head title="Parts" />
    <h1 class="mb-8 text-3xl font-bold">Parts</h1>
    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3 mb-6">
      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            30 Day Lead Count
          </h2>
        </div>
        <div>
          <canvas ref="barChart" />
        </div>
      </div>

      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Leads by Status
          </h2>
        </div>
        <div>
          <canvas ref="barChartStatus" />
        </div>
      </div>

      <div class="items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            30 Day Lead Count
          </h2>
        </div>
        <div>
          <canvas ref="doughnut" />
        </div>
      </div>

      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
             Closed This Year
          </h2>
        </div>
        <div>
          <canvas ref="barChartClosedThisYear" />
        </div>
      </div>

      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
             Closed This Month
          </h2>
        </div>
        <div>
          <canvas ref="barChartClosedThisMonth" />
        </div>
      </div>


      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Total Closed
          </h2>
        </div>
        <div>
          <canvas ref="barChartClosed" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Chart from 'chart.js/auto'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    loLeadCountThisMonth: Object,
    loClosed: Object,
    loClosedThisMonth: Object,
    loClosedThisYear: Object,
    processedLeadsByStatus: Object,
  },

  mounted() {
    this.$nextTick(() => {
      this.createChart(this.$refs.barChart, 'bar', 'Lead Count by Loan Officer', this.loLeadCountThisMonth);
      this.createChart(this.$refs.barChartClosedThisMonth, 'bar', 'Closed This Month', this.loClosedThisMonth);
      this.createChart(this.$refs.barChartClosedThisYear, 'bar', 'Closed This Year', this.loClosedThisYear);
      this.createChart(this.$refs.barChartClosed, 'bar', 'Total Closed', this.loClosed);
      this.createChart(this.$refs.barChartStatus, 'bar', 'Leads by Status', this.processedLeadsByStatus);
      this.createChart(this.$refs.doughnut, 'doughnut', 'Loan Officer Leads', this.loLeadCountThisMonth);
      this.createChart(this.$refs.polarArea, 'polarArea', 'Loan Officer Leads', this.loLeadCountThisMonth);
    });
  },

  methods: {
    createChart(canvasRef, type, label, data) {
      if (canvasRef) {
        const ctx = canvasRef.getContext('2d');
        const chart = new Chart(ctx, {
          type: type,
          data: {
            labels: data.map(item => item.name),
            datasets: [{
              label: label,
              data: data.map(item => item.count),
              backgroundColor: [
                '#1F96BF',  // Indigo 600
                '#FF0000',  // Red
                '#FF5722',  // Orange
                '#FFEB3B',  // Yellow
                '#9C27B0',  // Purple
                '#3EB1E5',  // Indigo 500
                '#4CAF50',  // Green
                '#3B82F6',  // Blue
                '#F472B6',  // Pink
                '#5CBEE0',  // Indigo 400
                '#6B7280',  // Gray
                '#FF9800',  // Bold Orange (custom)
                '#00C853',  // Bright Green
                '#F44336',  // Bold Red
                '#607D8B',  // Bold Blue Gray
                '#8E44AD',  // Dark Purple
                '#ADD3E0',  // Indigo 100
                '#03A9F4',  // Cyan
                '#FF1493',  // Deep Pink
                '#80C5DD',  // Indigo 300
              ],
              borderColor: [
                '#03485B',  // Indigo 900
                '#B71C1C',  // Dark Red
                '#BF360C',  // Deep Orange
                '#FBC02D',  // Deep Yellow
                '#7B1FA2',  // Deep Purple
                '#157089',  // Indigo 800
                '#388E3C',  // Dark Green
                '#1E40AF',  // Dark Blue
                '#DB2777',  // Deep Pink
                '#1F96BF',  // Indigo 600
                '#374151',  // Dark Gray
                '#EF6C00',  // Deep Orange
                '#2E7D32',  // Dark Green
                '#D32F2F',  // Dark Bold Red
                '#455A64',  // Dark Blue Gray
                '#512DA8',  // Dark Purple
                '#5CBEE0',  // Indigo 400
                '#0288D1',  // Deep Cyan
                '#C2185B',  // Dark Pink
                '#3EB1E5',  // Indigo 500
              ],
              borderWidth: 2,
              hoverOffset: 6,
            }],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          },
        });
      }
    },
  },
};
</script>
